export default "__VITE_ASSET__g_WOO$fc__"